'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dEnvelope$002dTitle$0024$0024anon$002421 from "./presto.types$-Envelope-Title$$anon$21.js";
import * as $j_presto$002etypes$0024$002dEnvelope$002dTitle$0024$0024anon$002422 from "./presto.types$-Envelope-Title$$anon$22.js";
var $p;
/** @constructor */
function $c_Lpresto_types$EnvelopeTitle$() {
  this.c64 = null;
  this.c65 = false;
  this.c62 = null;
  this.c63 = false;
  this.c66 = null;
  this.c67 = false;
  this.c68 = null;
  this.c69 = false;
}
export { $c_Lpresto_types$EnvelopeTitle$ as $c_Lpresto_types$EnvelopeTitle$ };
$p = $c_Lpresto_types$EnvelopeTitle$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$EnvelopeTitle$;
/** @constructor */
function $h_Lpresto_types$EnvelopeTitle$() {
}
export { $h_Lpresto_types$EnvelopeTitle$ as $h_Lpresto_types$EnvelopeTitle$ };
$h_Lpresto_types$EnvelopeTitle$.prototype = $p;
$p.cHu = (function() {
  if ((!this.c65)) {
    this.c64 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c65 = true;
  }
  return this.c64;
});
$p.nK = (function() {
  if ((!this.c63)) {
    this.c62 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.c63 = true;
  }
  return this.c62;
});
$p.cHW = (function() {
  if ((!this.c67)) {
    this.c66 = new $j_presto$002etypes$0024$002dEnvelope$002dTitle$0024$0024anon$002421.$c_Lpresto_types$EnvelopeTitle$$anon$21(this);
    this.c67 = true;
  }
  return this.c66;
});
$p.cIs = (function() {
  if ((!this.c69)) {
    this.c68 = new $j_presto$002etypes$0024$002dEnvelope$002dTitle$0024$0024anon$002422.$c_Lpresto_types$EnvelopeTitle$$anon$22(this);
    this.c69 = true;
  }
  return this.c68;
});
var $d_Lpresto_types$EnvelopeTitle$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$EnvelopeTitle$, "presto.types$EnvelopeTitle$", ({
  a0o: 1,
  D: 1
}));
export { $d_Lpresto_types$EnvelopeTitle$ as $d_Lpresto_types$EnvelopeTitle$ };
var $n_Lpresto_types$EnvelopeTitle$;
function $m_Lpresto_types$EnvelopeTitle$() {
  if ((!$n_Lpresto_types$EnvelopeTitle$)) {
    $n_Lpresto_types$EnvelopeTitle$ = new $c_Lpresto_types$EnvelopeTitle$();
  }
  return $n_Lpresto_types$EnvelopeTitle$;
}
export { $m_Lpresto_types$EnvelopeTitle$ as $m_Lpresto_types$EnvelopeTitle$ };
//# sourceMappingURL=presto.types$-Envelope-Title$.js.map
